import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { WeeklyResultByStoreReportService } from '../weekly-result-by-store-report/weekly-result-by-store-report.service';
import { ShopinfoService } from '../../system/shopinfo/shopinfo.service';
import { ShopinfoModel } from '../../system/shopinfo/model/shopinfo.model';
import { DatePipe } from '@angular/common';
import { TerminalService } from '../../system/terminal/terminal.service';
import { CashVarianceExceptionReportService } from './cash-variance-exception-report.service';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-cash-variance-exception-report',
  standalone: false,
  templateUrl: './cash-variance-exception-report.component.html',
  styleUrl: './cash-variance-exception-report.component.scss'
})
export class CashVarianceExceptionReportComponent implements OnInit {

  title: string = "Cash Variance Exception";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  requestData: any = null;
  selectedYear: any;
  weeks: any[] = [];
  terminalListData: any = [];
  financialYears: any[] = [];
  years: number[] = [];
  curFinYear!: string;
  shopListData: any = [];
  selectedShopIds: any = [];
  weekStartDate: any;
  weekEndDate: any;
  filteredShopList: any[] = [];
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private cashVarianceExceptionReportService: CashVarianceExceptionReportService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    public dialog: MatDialog,
    private datePipe: DatePipe,
    private permissionService: PermissionService,
    private ternimalService: TerminalService,) {

    const userData = sessionStorage.getItem('user');
    if (userData) {
      this.requestData = JSON.parse(userData);
      console.log('Request Data:', this.requestData);
    } else {
      console.log('Data not found in sessionStorage');
    }

    this.editForm = this.builder.group({
      week_no: this.builder.control([]),
      // shop_id: this.builder.control('', [Validators.required, this.shopValidator.bind(this)]),
      shop_id: this.builder.control({ id: null, name: 'ALL', code: 'ALL' }, [Validators.required, this.shopValidator.bind(this)]),

    });

    this.currentYear = new Date().getFullYear();

    // Automatically save to sessionStorage when form values change
    this.editForm.valueChanges.subscribe(() => {
      this.saveToSessionStorage();
    });

    this.loadData();
    this.shopList();
    this.permission = permissionService.getPagePermission("cash-variance-exception");
    console.log(this.permission);
  }

  ngOnInit(): void {
    // Add autocomplete filtering
    this.editForm.get('shop_id')?.valueChanges.subscribe(value => {
      this.filterShops();
    });

    this.editForm.get('week_no')?.valueChanges.subscribe((selectedWeekNo: number) => {
      const selectedWeek = this.weeks.find(week => week.week_no === selectedWeekNo);
      if (selectedWeek) {
        this.weekStartDate = selectedWeek.start_date;
        this.weekEndDate = selectedWeek.end_date;

        this.editForm.patchValue({
          week_start_date: selectedWeek.start_date,
          week_end_date: selectedWeek.end_date
        }, { emitEvent: false });
      }
    });
  }

  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }

  shopList(): void {
    let requestData = {
      search: {
        filters: {
          filter: [],
          scope: { offset: 0, limit: 1000000 }
        },
        sort: [{ column: "shop.name", order: "ASC" }]
      }
    }

    this.cashVarianceExceptionReportService.getShopList(requestData).subscribe({
      next: (response: any) => {
        // Add "ALL" option at the beginning
        const allOption = { id: null, name: 'ALL', code: 'ALL' };
        this.shopListData = [allOption, ...response.data.shops];
        this.filteredShopList = this.shopListData.slice(); // Initialize with copy including ALL
      },
      error: (error: any) => {
        console.error('Error fetching shops:', error);
      }
    });
  }

  sortOptions = [
    { value: 'shop_name', label: 'Shop Name' },
    { value: 'this_year_this_week_sales', label: 'This Year Sales' },
    { value: 'last_year_this_week_sales', label: 'Last Year Sales' },
    { value: 'this_week_cust_orders', label: 'This Year Customer Orders' },
    { value: 'last_year_cus_order', label: 'Last Year Customer Orders' },
    { value: 'this_week_labour_cost', label: 'This Year Labour Cost' },
    { value: 'last_year_this_week_labour_cost', label: 'Last Year Labour Cost' },
  ];

  sortOrderOptions = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
  ];

  saveToSessionStorage(): void {
    const selectedShopIds = this.terminalListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.id);

    const shopIds = selectedShopIds.length > 0 ? selectedShopIds : [];

    const reportData = {
      year: this.editForm.get('year')?.value,
      weekNo: this.editForm.get('week_no')?.value,
      shopId: shopIds,
      sortBy: this.editForm.get('sort_by')?.value,
      sortDir: this.editForm.get('sort_order')?.value,
      isExport: 0
    };

    sessionStorage.setItem('weeklyStoreReportData', JSON.stringify(reportData));
  }

  loadFromSessionStorage(): void {
    const savedData = sessionStorage.getItem('weeklyStoreReportData');
    if (savedData) {
      const reportData = JSON.parse(savedData);

      this.editForm.patchValue({
        year: reportData.year,
        week_no: reportData.weekNo,
        sort_by: reportData.sortBy,
        sort_order: reportData.sortDir
      }, { emitEvent: false });

      if (reportData.shopId && reportData.shopId.length > 0) {
        this.terminalListData.forEach((shop: any) => {
          shop.selected = reportData.shopId.includes(shop.item.id);
        });
      } else {
        this.terminalListData.forEach((shop: any) => shop.selected = false);
      }

      if (reportData.year) {
        this.onYearChange();
      }
    }
  }

  buildRequestData(): any {
    return {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: "100",
            offset: "0"
          }
        },
        sort: [
          {
            column: "wd.year",
            order: "desc"
          }
        ]
      }
    };
  }

  loadData(): void {
    const requestData = this.buildRequestData();
    this.cashVarianceExceptionReportService.getWeekNoList(requestData).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.financialYears = response.data.finYears;
        this.curFinYear = response.data.curFinYear;
        const currentYearValue = parseInt(this.curFinYear.split('-')[0]);

        this.financialYears = this.financialYears.filter((fy: any) => fy.year <= currentYearValue);

        let allWeeks: any[] = [];
        let selectedWeek: any = null;

        this.financialYears.forEach(fy => {
          let weeksArray = fy.weeks;

          if (fy.year === currentYearValue) {
            const currentWeek = this.getCurrentWeek(weeksArray);
            if (currentWeek) {
              weeksArray = weeksArray.filter((week: any) => week.week_no <= currentWeek.week_no);
              selectedWeek = currentWeek;
            }
          }

          const formattedWeeks = weeksArray.map((week: any) => ({
            ...week,
            year: fy.year,
            displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
          }));

          allWeeks.push(...formattedWeeks);
        });

        allWeeks.sort((a, b) => new Date(b.start_date).getTime() - new Date(a.start_date).getTime());
        this.weeks = allWeeks;

        if (!selectedWeek && this.weeks.length > 0) {
          selectedWeek = this.weeks[this.weeks.length - 1];
        }

        if (selectedWeek) {
          this.editForm.get('week_no')?.setValue(selectedWeek.week_no, { emitEvent: false });
          this.weekStartDate = selectedWeek.start_date;
          this.weekEndDate = selectedWeek.end_date;
        }
      }
    });
  }

  onYearChange(): void {
    const selectedYear = this.editForm.get('year')?.value;
    const selectedFinYear = this.financialYears.find(fy => fy.year === selectedYear);

    if (selectedFinYear) {
      let weeksArray = selectedFinYear.weeks;
      const isCurrentYear = selectedYear === parseInt(this.curFinYear.split('-')[0]);

      if (isCurrentYear) {
        const currentWeek = this.getCurrentWeek(weeksArray);
        if (currentWeek) {
          weeksArray = weeksArray.filter((week: any) => week.week_no <= currentWeek.week_no);
        }
      }

      this.weeks = weeksArray.map((week: any) => ({
        ...week,
        displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
      }));

      if (this.weeks.length > 0) {
        this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('week_no')?.setValue(null);
    }
  }

  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }

  TerminalList(): void {
    let requestData = {
      search: {
        filters: {
          filter: [],
          scope: { offset: 0, limit: 1000000 }
        },
        sort: [{ column: "name", order: "ASC" }]
      }
    }

    this.ternimalService.getTerminalList(requestData).subscribe(
      (response: any) => {
        this.terminalListData = [];
        var index = 0;
        response.data.terminals.forEach((item: any) => {
          var data = { index: index, item: item, selected: false };
          this.terminalListData.push(data);
          index++;
        });
        console.log(this.terminalListData)
      },
      (error: any) => {
      },
    );
  }

  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }

  reset(sourceList: any[]): any {
    sourceList.forEach(el => {
      el.selected = false;
    });
  }

  onShopSelectionChange(): void {
    this.saveToSessionStorage();
  }

  navigateToWeeklyReport() {
    this.router.navigate(['/weekly-result-store-report-view']);
  }

  exportClicked(): void {
    if (this.editForm.valid) {
      this.IsDownloading = true;

      const selectedShopId = this.editForm.get('shop_id')?.value;

      // Handle "ALL" option - if ALL is selected or shopId is null, pass null
      let shopId = null;
      if (selectedShopId && typeof selectedShopId === 'object') {
        shopId = selectedShopId.id; // This will be null for "ALL" option
      } else if (selectedShopId && selectedShopId !== 'ALL') {
        shopId = selectedShopId;
      }

      const reportData = {
        weekNo: this.editForm.get('week_no')?.value,
        weekStartDate: this.weekStartDate,
        weekEndDate: this.weekEndDate,
        shopIds: shopId // Will be null when "ALL" is selected
      };

      if (reportData) {
        this.cashVarianceExceptionReportService.getCashVarianceExportList(reportData).subscribe({
          next: (response: Blob) => {
            const reader = new FileReader();

            reader.onload = () => {
              try {
                const text = reader.result as string;
                const json = JSON.parse(text);

                if (json.status === 'NO_DATA_FOUND') {
                  let snackBarData: SnackBarData = {
                    message: 'No data found.',
                    title: 'No Data!!!',
                    type: 'warn'
                  }
                  this.IsDownloading = false
                  this.snackBarService.openSnackBar(snackBarData);
                  return;
                }
              } catch (e) {
                const blob = new Blob([response], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'cash-variance-exception-report.csv';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                this.IsDownloading = false
              }
            };

            reader.readAsText(response);
          },
          error: (error) => {
            console.error('Error fetching report:', error);
            this.IsDownloading = false
          }
        });
      }
    } else {
      this.editForm.markAllAsTouched();
      let snackBarData: SnackBarData = {
        message: 'Please fill all required fields.',
        title: 'Validation Error',
        type: 'error'
      };
      this.snackBarService.openSnackBar(snackBarData);
    }
  }

  filterShops() {
    const value = this.editForm.get('shop_id')?.value;
    if (!value || value === '' || value === 'ALL' || (typeof value === 'object' && value.name === 'ALL')) {
      this.filteredShopList = this.shopListData.slice();
      return;
    }

    const filterValue = typeof value === 'string' ? value.toLowerCase() : (value?.name?.toLowerCase() || '');
    this.filteredShopList = this.shopListData.filter((shop: any) =>
      shop.name.toLowerCase().includes(filterValue)
    );
  }

  displayShop(shop: any): string {
    return shop && shop.name ? shop.name : '';
  }

  clearShop() {
    this.editForm.get('shop_id')?.setValue('');
    this.filteredShopList = this.shopListData.slice();
  }

  shopValidator(control: any) {
    if (!control.value) return { invalidShop: true };

    // Allow "ALL" option (with id: null)
    if (typeof control.value === 'object' && (control.value.id === null || control.value.name === 'ALL')) {
      return null;
    }

    if (typeof control.value === 'object' && this.shopListData.some((shop: { id: any; }) => shop.id === control.value.id)) {
      return null;
    }
    if (typeof control.value === 'string' && this.shopListData.some((shop: { name: any; }) => shop.name === control.value)) {
      return null;
    }
    return { invalidShop: true };
  }

  getShopObject(id: any) {
    return this.shopListData?.find((shop: { id: any; }) => shop.id == id) || '';
  }
}
